import React, { useState } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Waypoint } from 'react-waypoint'
import { ScrolledIntoView, EVENTS_LABELS } from 'src/constants/trackingEvents'
import RefiDetailsOverlay from 'src/Components/homeowners/RefiDetailsOverlay/RefiDetailsOverlay'
import Text from 'src/Components/shared/Text'
import RefiHeading from 'src/Components/shared/RefiHeading'
import YearsInHomeSlider from './YearsInHomeSlider'
import RefiOptionReveal from './RefiOptionReveal'
import { oneTimeTagEventDispatcher } from 'src/helpers/tagManager'

import styles from './RefiByYearsInHome.module.scss'

const propTypes = {
  className: PropTypes.string
}

const scrollIntoView = oneTimeTagEventDispatcher(ScrolledIntoView, {
  eventLabel: EVENTS_LABELS.RefiScenariosSection
})

const RefiByYearsInHome = ({
  className,
  fha,
  isConsolidation,
  refiDetails,
  yearsInHome,
  pmi,
  navRefiOption,
  setYearsInHome,
  locked
}) => {
  const [years, setYears] = useState(yearsInHome)
  const [mouseDown, setMouseDown] = useState(false)

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={classnames(styles.root, className)}
      onMouseUp={() => {
        setMouseDown(false)
        if (years !== yearsInHome) {
          setYearsInHome(years)
        }
      }}
    >
      <Text color='quiet' align='center' size='s'>
        <FormattedMessage
          id='RefiByYearsInHome.subHeading'
          defaultMessage='Based on current national rate trends:'
        />
      </Text>
      <RefiHeading
        isFha={!!fha}
        isConsolidation={isConsolidation}
        className={styles.heading}
      />
      <Waypoint onEnter={scrollIntoView} bottomOffset='50%'>
        <div />
      </Waypoint>
      <YearsInHomeSlider
        min='1'
        max='30'
        value={mouseDown ? years : yearsInHome}
        onMouseDown={() => setMouseDown(true)}
        onChange={e =>
          mouseDown ? setYears(e.target.value) : setYearsInHome(e.target.value)
        }
      />
      <RefiDetailsOverlay options={refiDetails} />
      <RefiOptionReveal
        yearsInHome={yearsInHome}
        pmi={pmi}
        onClickOption={navRefiOption}
        options={refiDetails}
        locked={locked}
      />
    </div>
  )
}

RefiByYearsInHome.propTypes = propTypes

export default RefiByYearsInHome
